import React, {ReactNode} from 'react';
import './ListView.scss'

export interface ListViewProps {
  children: ReactNode;
}

const ListView: React.FC<ListViewProps> = ({children}) => {
  return (
      <ol className='listview'>
        {children}
      </ol>
  );
}

export default ListView;
